module.exports = __webpack_public_path__ + "static/media/8.26cd9ace.jpg";